import React, { useState, useRef } from 'react';
import Button from '../button';
import PopperContainer from './popperContainer';
import { ButtonMenu, Dot } from './verticalDot.style';
import { isEmpty } from 'lodash';

interface ActionButtonType {
  actions?: any[];
  id?: string | number | undefined;
  rowData?: Record<string, string>;
  counter?: number;
  as?: string;
  variant?: string;
  icon?: string;
  buttonTitle?: string;
  disable?: boolean;
  hideMenuOnActionClick?: boolean;
  doubleTable?: boolean;
  renderPopoverInPortal?: boolean;
  domId?: string;
}

export const ActionButton = ({
  actions,
  id,
  rowData,
  counter,
  as,
  disable = false,
  doubleTable,
  buttonTitle,
  icon,
  variant,
  renderPopoverInPortal,
  hideMenuOnActionClick,
  domId
}: ActionButtonType): JSX.Element => {
  const [show, setShow] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Generate unique button ID using domId, buttonTitle, or fallback
  const buttonId = domId || buttonTitle?.toLowerCase().replace(/\s+/g, '') || `actionButton.${counter}`;

  const handleShow = (value?: boolean): void => {
    value ?? false ? setShow(value ?? false) : setShow(!show);
  };

  const filteredActions = actions?.filter((action) => {
    if (action.isHidden && typeof action.isHidden === 'function' && rowData) {
      return !action.isHidden(rowData);
    }
    return true;
  });

  // Generate test IDs following established patterns
  const actionsMenuId = `row.${counter}.actions`;

  return (
    <>
      {as === 'Button' ? (
        <>
          <ButtonMenu ref={buttonRef}>
            <Button
              id={buttonId}
              type='button'
              variant={variant ? variant : 'secondary-white'}
              title={buttonTitle ? buttonTitle : 'Plan Options'}
              icon={icon ? icon : 'edit'}
              onClick={() => {
                handleShow();
              }}
            />
          </ButtonMenu>
          <PopperContainer
            id={id}
            className='limit-height-btn'
            actions={actions?.map((action) => {
              if (!hideMenuOnActionClick) return action;
              return {
                ...action,
                onClick: (index: string) => {
                  action?.onClick(index, rowData);
                  handleShow(false);
                },
              };
            })}
            rowData={rowData}
            referenceElement={buttonRef}
            counter={counter}
            show={show}
            handleShow={handleShow}
            renderPopoverInPortal={renderPopoverInPortal}
            doubleTable={doubleTable}
          />
        </>
      ) : (
        <>
          <Dot key={counter} className='cursor-pointer' disable={disable}>
            <span
              id={actionsMenuId}
              className={`material-symbols-outlined ${show ? 'active' : ''}`}
              ref={buttonRef}
              onClick={() => {
                disable ? '' : handleShow();
              }}>
              more_vert
            </span>
          </Dot>
          <PopperContainer
            id={id}
            actions={filteredActions?.map((action) => {
              if (!hideMenuOnActionClick) return action;
              return {
                ...action,
                onClick: (index: string) => {
                  action?.onClick(index, rowData);
                  handleShow(false);
                },
              };
            })}
            rowData={rowData}
            referenceElement={buttonRef}
            counter={counter}
            show={show}
            handleShow={handleShow}
            doubleTable={doubleTable}
            renderPopoverInPortal={renderPopoverInPortal}
          />
        </>
      )}
    </>
  );
};